import React from "react";

import Images from "./images";

class ImagesContainer extends React.Component {
  constructor(props) {
    super(props);

    // arbitrary business logic
    this.fakeData = "fake data";
  }

  render() {
    return (
      <Images
        images={this.props.data}
        handleImageCreate={this.props.handleImageCreate}
        handleImageLoaded={this.props.handleImageLoaded}
      />
    );
  }
}
export default ImagesContainer;
